import { applicationConstants, mainActionsConstants } from "../actions/constants";
import { } from './../actions/constants';

const initialState = {
    applications: [],
    applicationObj: {},
    message: "",
    showAlert: false,
    variantAlert: "success",

};

export default (state = initialState, action) => {
    switch (action.type) {
        case applicationConstants.GET_ALL_APPLICATION_SUCCESS:
            state = {
                ...state,
                applications: action.payload.applications
            }
            break;
        case applicationConstants.DELETE_APPLICATION_BY_ID_SUCCESS:
            state = {
                ...state,
                showAlert: true,
                variantAlert: "success",
                loading: false
            }
            break;
        case applicationConstants.DELETE_MANY_REQUEST:
            state = {
                ...state,
                loading: true
            };
        case applicationConstants.DELETE_MANY_SUCCESS:
            state = {
                ...state,
                loading: false,
            };
            break;
        case applicationConstants.DELETE_MANY_FAILURE:
            state = {
                ...state,
                loading: false,
            };
            break;
        case mainActionsConstants.GET_BY_ID_REQUEST:
            state = {
                ...state,
                loading: true
            };
        case mainActionsConstants.GET_BY_ID_SUCCESS:
            state = {
                ...state,
                applicationObj: action.payload?.item,
                loading: false,
            };
            break;
        case mainActionsConstants.GET_BY_ID_FAILURE:
            state = {
                ...state,
                loading: false,
            };
            break;
        case mainActionsConstants.CANCELLATION_STATUS_REQUEST:
            state = {
                ...state,
                loading: true,
            };
            break;
        case mainActionsConstants.CANCELLATION_STATUS_SUCCESS:
            state = {
                ...state,
                loading: false,
                variantAlert: "success",
                message: action.payload.message,
                applicationObj: action.payload.result,
                showAlert: true,
            };
            break;
        case mainActionsConstants.CANCELLATION_STATUS_FAILURE:
            state = {
                ...state,
                loading: false,
                message: action.payload.message,
                variantAlert: "warning",
                showAlert: true,
            };
            break;


        case applicationConstants.UPDATE_STATUS_REQUEST:
            state = {
                ...state,
            }
            break;
        case applicationConstants.UPDATE_STATUS_SUCCESS:
            state = {
                ...state,
                applicationObj: action.payload.result,
                showAlert: true,
                variantAlert: "success",
                loading: false
            }
            break;
        case applicationConstants.UPDATE_STATUS_FAILURE:
            state = {
                ...state,
                showAlert: true,
                variantAlert: "warning",
                loading: false
            }
            break;
        case applicationConstants.UPDATE_STATUS_REQUEST:
            state = {
                ...state,
            }
            break;
        case applicationConstants.UPDATE_STATUS_SUCCESS:
            state = {
                ...state,
                applications: action.payload.applications,
                showAlert: true,
                variantAlert: "success",
                loading: false
            }
            break;
        case applicationConstants.UPDATE_STATUS_FAILURE:
            state = {
                ...state,
                showAlert: true,
                variantAlert: "warning",
                loading: false
            }
            break;
        case applicationConstants.CLOSE_ALERT:
            state = {
                ...state,
                showAlert: false
            }
            break;
        default:
            return state
    }

    return state;
}
export const setCloseAlertApplication = (payload) => ({ type: applicationConstants.CLOSE_ALERT, payload })

export const setApplication = (applications) => ({ type: applicationConstants.GET_ALL_APPLICATION_SUCCESS, payload: applications })
